import { createReducer, on } from '@ngrx/store';
import { setTaxAction } from './tax.actions';



export const initialState = 16;

export const taxReducer = createReducer(
  initialState,
  on(setTaxAction, (state, { tax }) => tax)
);